import { ADD_SERVICE_EMAIL, FETCH_SERVICE_DETAILS } from "../actionTypes"
import { addAdditionalEmail, fetchServiceDetail } from "../../../api/incidentManagement/serviceDetails.service"

const serviceDetailRequest = ()=>({type: FETCH_SERVICE_DETAILS.REQUEST})
const serviceDetailFailure = (error)=>({type: FETCH_SERVICE_DETAILS.FAILURE, error})
const serviceDetailSuccess = (obj)=>({type: FETCH_SERVICE_DETAILS.SUCCESS, obj})

export const getServiceDetail = (requestId)=>{
    return (dispatch, getState)=>{        
        dispatch(serviceDetailRequest())
        return fetchServiceDetail(requestId)
        .then(response => {
            dispatch(serviceDetailSuccess(response))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(serviceDetailFailure(error?.message))
            return Promise.resolve(false)
        })
    }
}

const addEmailRequest = ()=>({type: ADD_SERVICE_EMAIL.REQUEST})
const addEmailFailure = (error)=>({type: ADD_SERVICE_EMAIL.FAILURE, error})
const addEmailSuccess = (obj)=>({type: ADD_SERVICE_EMAIL.SUCCESS, obj})

export const addEmail = (payload,id) => {
  return (dispatch, getState) => {
    dispatch(addEmailRequest());
    return addAdditionalEmail(payload,id)
      .then((res) => {
        dispatch(addEmailSuccess(res));
        return Promise.resolve({res:res,status:true});

      })
      .catch((error) => {
        dispatch(addEmailFailure(error?.message));
        return Promise.resolve({error:error?.message,status:false,code:error?.code});
      })
  }
}